import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { broadcastScheduleQueryKeys } from '@/features/broadcast-schedule/api/query-keys';
import { TProgramBroadcast } from '@/features/broadcast-schedule/types';
import { MutationConfig } from '@/lib/react-query';
import { useNotificationStore } from '@/stores/notifications';

import { patchProgramBroadcast } from './patch-broadcast-schedule';

async function unlinkAudienceFileFromProgramBroadcast(id: string): Promise<TProgramBroadcast> {
  return patchProgramBroadcast({
    id,
    audience_program_source_id: null,
  });
}

type MutationFn = typeof unlinkAudienceFileFromProgramBroadcast;

type TUseUnlinkAudienceFileFromProgramBroadcast = {
  config?: MutationConfig<MutationFn>;
};

export function useUnlinkAudienceFileFromProgramBroadcast({
  config,
}: TUseUnlinkAudienceFileFromProgramBroadcast = {}) {
  const queryClient = useQueryClient();
  const { t } = useTranslation();

  const { addErrorNotification, addSuccessNotification } = useNotificationStore();

  return useMutation({
    ...config,
    onError(error) {
      addErrorNotification(
        t('No se han podido desvincular'),
        t('Ha habido un fallo en el proceso')
      );
      console.error(error);
    },
    onSuccess(data, variables, context) {
      config?.onSuccess?.(data, variables, context);
      addSuccessNotification(t('Se ha desvinculado el archivo'), t('El proceso ha sido un éxito'));
      queryClient.invalidateQueries({
        queryKey: broadcastScheduleQueryKeys.broadcastSchedule(),
      });
    },
    mutationFn: unlinkAudienceFileFromProgramBroadcast,
  });
}
